import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Configuration values for local are defined in /client/src/assets other environments in client/configuration
 */
export interface IConfiguration {
  deploymentEnvironment: 'local' | 'dev' | 'qa' | 'prd';
  issuer: string;
  clientId: string;
  identityTestApplicationUrl: string;
  sumoLoggingSourceEndpoint: string;
  helpUrl: string;
}

export interface IAppConfiguration extends Document {
  env?: IConfiguration;
}

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService {
  constructor(@Inject(DOCUMENT) private document: IAppConfiguration) {}

  public getConfiguration(): IConfiguration {
    return <IConfiguration>this.document.env;
  }
}
